module.exports = __webpack_public_path__ + "static/media/default_sound.7fe2fdae.mp3";